/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S1_P1Inputs */

const en_guide_large_json_files_s1_p1 = /** @type {(inputs: Guide_Large_Json_Files_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most JSON parsers load the entire document into memory at once. A 500 MB JSON file can easily consume 2-4 GB of RAM when parsed into objects due to memory overhead from data structures, pointers, and string representations.`)
};

const ko_guide_large_json_files_s1_p1 = /** @type {(inputs: Guide_Large_Json_Files_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대부분의 JSON 파서는 전체 문서를 한 번에 메모리에 로드합니다. 500 MB JSON 파일은 데이터 구조, 포인터, 문자열 표현의 메모리 오버헤드로 인해 객체로 파싱할 때 쉽게 2-4 GB의 RAM을 소모할 수 있습니다.`)
};

const ja_guide_large_json_files_s1_p1 = /** @type {(inputs: Guide_Large_Json_Files_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほとんどのJSONパーサーは、ドキュメント全体を一度にメモリに読み込みます。500MBのJSONファイルは、データ構造、ポインタ、文字列表現のメモリオーバーヘッドにより、オブジェクトにパースする際に簡単に2〜4GBのRAMを消費する可能性があります。`)
};

/**
* | output |
* | --- |
* | "Most JSON parsers load the entire document into memory at once. A 500 MB JSON file can easily consume 2-4 GB of RAM when parsed into objects due to memory ov..." |
*
* @param {Guide_Large_Json_Files_S1_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s1_p1 = /** @type {((inputs?: Guide_Large_Json_Files_S1_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S1_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s1_p1(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s1_p1(inputs)
	return ja_guide_large_json_files_s1_p1(inputs)
});